import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaNarrationApplied = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(6, 4)">
        <path
          d="M12.8485 0.351472C12.6235 0.126428 12.3183 0 12 0H3.6C1.61177 0 0 1.61177 0 3.6V22.8C0 24.7882 1.61177 26.4 3.6 26.4H9.67089C10.3336 26.4 10.8709 25.8627 10.8709 25.2C10.8709 24.5373 10.3336 24 9.67089 24H3.6C2.93726 24 2.4 23.4627 2.4 22.8V3.6C2.4 2.93726 2.93726 2.4 3.6 2.4H11.5029L19.2 10.0971V13.5797C19.2 14.2425 19.7373 14.7797 20.4 14.7797C21.0627 14.7797 21.6 14.2425 21.6 13.5797V9.6C21.6 9.28174 21.4736 8.97652 21.2485 8.75147L12.8485 0.351472Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2 8.4H20.4001C21.0628 8.4 21.6 8.93726 21.6 9.6C21.6 10.2627 21.0628 10.8 20.4001 10.8H12C11.3373 10.8 10.8 10.2627 10.8 9.6V1.2C10.8 0.537258 11.3373 0 12 0C12.6628 0 13.2 0.537258 13.2 1.2V8.4Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.4228 24.4253C27.4228 28.6087 24.0315 32 19.8481 32C15.6647 32 12.2734 28.6087 12.2734 24.4253C12.2734 20.2419 15.6647 16.8506 19.8481 16.8506C24.0315 16.8506 27.4228 20.2419 27.4228 24.4253ZM22.9135 21.2122L19.0279 25.5435L16.9954 23.511C16.5268 23.0424 15.767 23.0424 15.2983 23.511C14.8297 23.9796 14.8297 24.7394 15.2983 25.208L18.1793 28.0891C18.648 28.5577 19.4078 28.5577 19.8764 28.0891L24.6106 22.9093C25.0792 22.4407 25.0792 21.6809 24.6106 21.2122C24.1419 20.7436 23.3821 20.7436 22.9135 21.2122Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaNarrationApplied.displayName = 'LlamaNarrationApplied';
